<template>
  <div>
    <v-layout row wrap>
      <v-flex grow>
        <h2 class="headline pb-3">Maintenance</h2>
      </v-flex>
      <v-flex shrink>
        <v-btn color="primary" @click.stop="addRepair()">
          <v-icon>add</v-icon>
          Add
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex>
        <v-list v-if="runningRepairs.length > 0" subheader>
          <template v-for="repair in runningRepairs">
            <v-list-tile
              :key="repair.id"
              class="repair"
              @click="showSelectedRepairFromId(repair.id)"
            >
              <v-list-tile-avatar class="avatar">
                <v-icon>handyman</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{repair.description }}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  {{repair.showStatus}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <div style="display:flex" class="chips-container">
                  <v-chip small >
                   {{ repair.lastDays }}
                  </v-chip>
                </div>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-flex>

    </v-layout>
    <RepairTaskDialog ref="dlg"/>
  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import RepairTaskDialog from '@/components/repairs/RepairTaskDialog'
import repairStatus from '@/helpers/repair_status'

export default {
  name: 'DetailsRepairs',
  components: { RepairTaskDialog },
  computed: {
    ...mapGetters({
      repairs: 'Repairs/get',
      selectedRepair: 'Repairs/getSelected',
      selectedHouse: 'HouseList/getSelectedHouse',
    }),
    runningRepairs() {
      let arr = this.repairs
      return arr;
    }
  },
  filters: {
    moment(date) {
      return moment.unix(date).format('MMM Do YYYY');
    }
  },
  methods: {
    ...mapActions({
      add: 'Repairs/add',
      fetchAll: 'Repairs/fetchAll',
      selectRepair: 'Repairs/select',
    }),
    ...mapMutations({
      selectRepairFromId: 'Repairs/selectFromId',
    }),
    async addRepair() {
      let repair = {
        house: this.selectedHouse,
        house_id: this.selectedHouse.id,
        title: 'maintenance',
        timestamp: moment().unix(),
        description: ''
      }
      const repairId = await this.add(repair)
      await this.fetchAll(this.selectedHouse.id)
      this.showSelectedRepairFromId(repairId)
    },
    async showSelectedRepairFromId(repairId) {
      await this.selectRepairFromId(repairId)
      await this.$refs.dlg.open()
    },
  },
  async mounted() {
    const houseId = this.selectedHouse.id;
    await this.fetchAll(houseId);
  }
}
</script>
